import React from 'react'
// import JSONEditor from 'jsoneditor/dist/jsoneditor'
// import 'jsoneditor/dist/jsoneditor.css'

interface JsonEditorProps {
  value?: any
  options?: any
  onChange?: (value: string) => void
  onError?: (error: { hasError: boolean; errors: any[] }) => void
  onDirty?: () => void
  className?: string
  style?: React.CSSProperties
}

interface JsonEditorState {
  dirty: boolean
  controllingFocus?: boolean
}

class JsonEditor extends React.PureComponent<JsonEditorProps, JsonEditorState> {
  timeout: NodeJS.Timeout | undefined = undefined

  editor: any = null

  div: HTMLDivElement | null = null

  constructor(props: JsonEditorProps) {
    super(props)
    this.state = {
      dirty: false,
    }
  }

  componentDidMount(): void {
    const { value, options } = this.props

    const mergedOptions = {
      ...options,
      onChange: this.handleChange,
      onValidationError: this.handleError,
    }

    this.getJSONEditor(mergedOptions).then(() => {
      this.setValue(value)
    })
  }

  componentDidUpdate(prevProps: JsonEditorProps): void {
    const { onDirty, value } = this.props
    const { dirty, controllingFocus } = this.state

    if (dirty === true && controllingFocus && onDirty) {
      onDirty()
    }

    if (dirty === true && !controllingFocus) {
      this.timeout = setTimeout(() => {
        this.setState({
          dirty: false,
        })
      }, 100)
    }

    if (controllingFocus) {
      clearTimeout(this.timeout)
    }

    if (prevProps.value !== value) {
      this.setValue(value)
      setTimeout(() => {
        this.setState({
          dirty: false,
        })
      }, 1)
    }
  }

  componentWillUnmount(): void {
    if (this.editor) {
      this.editor.destroy()
      delete this.editor
    }
    clearTimeout(this.timeout)
  }

  getJSONEditor = async (mergedOptions: any): Promise<any> => {
    const { default: JSONEditor } = await import('jsoneditor/dist/jsoneditor')
    await import('jsoneditor/dist/jsoneditor.css')

    this.editor = new JSONEditor(this.div, mergedOptions)

    return this.editor
  }

  setValue = (value: any): void => {
    if (value != null) {
      if (typeof value === 'string') {
        if (value !== this.editor.getText()) {
          this.editor.setText(value)
        }
      } else {
        this.editor.set(value)
      }
    } else {
      this.editor.setText('{}')
    }
    if (this.div != null) {
      ;(this.div as any).value = value
      this.div.setAttribute('value', value)
    }
  }

  getValue = (): string => {
    return this.editor.getText()
  }

  handleChange = (): void => {
    const { onChange } = this.props

    const value = this.editor.getText()

    console.log('validate : ', this.editor.validate())
    if (onChange != null) {
      onChange(value)
    }
    if (this.div != null) {
      ;(this.div as any).value = value
      this.div.setAttribute('value', value)
    }
  }

  handleFocus = (): void => {
    this.setState({
      controllingFocus: true,
    })
  }

  handleBlur = (): void => {
    this.setState({
      controllingFocus: false,
    })
  }

  handleError = (e: any[]): void => {
    const { onError } = this.props

    console.log('handleError : ', e)

    if (onError != null) {
      onError({
        hasError: e.length > 0,
        errors: e,
      })
    }
  }

  render(): React.ReactNode {
    const { className, style } = this.props

    return (
      <div
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        className={className}
        style={style}
        ref={(div) => {
          this.div = div
        }}
      />
    )
  }

  static defaultProps = {
    config: {},
    onDirty: () => {},
  }
}

export default JsonEditor
